// extracted by mini-css-extract-plugin
export default {"wrap":"CoverAbout_wrap__Uv9La","inner":"CoverAbout_inner__INeys","title":"CoverAbout_title__DQKPo","text":"CoverAbout_text__aPTHm","figure":"CoverAbout_figure__sXLpS"};